import { apiSlice } from "../../../app/api/apiSlice";

export const chatSessionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    v2getChatSessions: builder.query({
      query: (params) => ({
        url: "/api/v2/resources/chat_sessions/detailed/",
        params,
      }),
      providesTags: ["ChatSession"],
    }),
    v2fetchChatSessionById: builder.query({
      query: (id) => `/api/v2/resources/chat_sessions/${id}/`,
      providesTags: (result, error, id) => [{ type: "ChatSession", id }],
    }),
    v2createChatSession: builder.mutation({
      query: (args) => ({
        url: "/api/v2/resources/chat_sessions/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["ChatSession"],
    }),
    v2deleteChatSession: builder.mutation({
      query: (id) => ({
        url: `/api/v2/resources/chat_sessions/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ChatSession"],
    }),
  }),
});

export const {
  useV2getChatSessionsQuery,
  useV2fetchChatSessionByIdQuery,
  useV2createChatSessionMutation,
  useV2deleteChatSessionMutation,
} = chatSessionsApiSlice;
